<template>
    <div>
        <b-form-group
            label="ID Document Type"
            label-for="documentType"
            class="required-field"
        >
            <b-form-select
                v-model="model"
                v-validate="{
                    required: true,
                }"
                class="form-control"
                :options="options"
                :disabled="loading || disabled"
                data-vv-name="document type"
                :class="{
                    'is-invalid': errors.has('document type'),
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>
<script>
import Dropdown from './Dropdown.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    title: 'Select ID Document Type',
                    label: 'ID Document Type',
                    placeholder: 'Select ID Document Type',
                    options: [
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                        {
                            text: 'National Identity Card for Overseas Pakistanis',
                            value: 'id',
                        },
                        {
                            text: 'Passport',
                            value: 'passport',
                        },
                        {
                            text: 'Pakistan Origin Card',
                            value: 'poc',
                        },
                        {
                            text: 'National Alien Registration System',
                            value: 'arc',
                        },
                    ],
                    key: 'identityInfo.type',
                }
            },
            required: false,
        },
        dataSegmentId: {
            type: String,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model() {
            this.$store.commit('updateField', {
                key: 'documentInfo.identity',
                value: {
                    originalFileName: null,
                    fileName: null,
                },
            })
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.options = this.field.options
    }, // End of Component > watch
}
</script>
